/**
 *
 * info-box.
 *
 */

module.exports = {

  init: function () {
    $('.info-container__close').click(function() {
      $(this).parent().slideToggle(300);
    });
  }
}



// WEBPACK FOOTER //
// ./js/mywort/styleguide/infobox.js